<headband></headband>
<img src="assets/v8te.png" id="logo" alt="logo" width="150px" />

<div id="container" class="w-full text-center mt-50 flex-col content-center" style="height: 80%;">
  <h1 class="bold dark-blue text-xxl">CE LIEN D'AUTHENTIFICATION N'EST PLUS VALIDE</h1>
  <div id="error">
    <h1 class="dark-blue text-md no-margin">(CODE ERREUR 410)</h1>
  </div>


  <div>
    <img class="mt-30 mb-50" src="assets/recover-shield-icon.svg" id="shield" alt="shield" width="180px" />
  </div>

  <div>
    <p class="dark-gray no-margin">Si vous pensez qu’il s’agit d’une erreur</p>
    <p class="bold dark-blue">VEUILLEZ CONTACTER NOTRE SUPPORT</p>
    <span id="down-arrow" style="display: block; margin: 5px 0;">
      <svg width="20" height="15" viewBox="0 0 20 15">
        <polygon points="10,15 0,0 20,0" fill="#2B2D67" stroke="#2B2D67" stroke-width="2" stroke-linejoin="round" />
      </svg>
    </span>
    <a href="mailto:support_client@v8te.com" class="mt-5">support_client&#64;v8te.com</a>
  </div>

</div>